import React from "react";

export const BaseTestnetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_75_249)">
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#FFB300"
      />
      <path
        d="M10.0442 16.9491C13.9201 16.9491 17.062 13.8125 17.062 9.94339C17.062 6.07428 13.9201 2.93774 10.0442 2.93774C6.36701 2.93774 3.35038 5.76096 3.05078 9.35451H12.3268V10.5323H3.05078C3.35038 14.1258 6.36701 16.9491 10.0442 16.9491Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_75_249">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
